<template>
    <div>
        <div class="text-book" style="margin-top: 10px;">
            <div class="title">{{courseInfo.edition_name}}{{courseInfo.curriculum_id_name}}</div>
            <div class="title-text">单词基础：以单词为核心，对单词，句子等进行基础与提高学习，并且可就全书范围进行智能听写。</div>
        </div>
        <div class="text-book">
            <div class="title">综合学习</div>
            <div class="class-btn">
                <div class="color-1" @click="startWordSpell()">
                    智能听写
                </div>
                <div class="color-2" @click="startComparision">
                    对比测试
                </div>
                <div class="color-3" @click="preciseReview()">
                    精准复习
                </div>
                <div class="color-4" @click="checkUnitEnd">
                    本书测试
                    <transition name="el-zoom-in-center">
                        <div class="lock-unit" v-if="showBookPop">还未学完该教材</div>
                    </transition>
                </div>
                <div class="color-5" @click="startAllTest">
                    一测到底
                    <transition name="el-zoom-in-center">
                        <div class="lock-unit" v-if="showAllTestPop">还未学完该教材</div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="menu-link">
            <template v-for="(item,index) in menuLink">    
                <div class="title" :class="{'active-item': $route.query.type == item.type}"
                    @click="goLink(item)"
                    :key="'a-'+index"
                    v-if="courseInfo.is_open&&item.type < 3 || !courseInfo.is_open"
                >{{item.name}}
                </div>
            </template>
        </div>
        <transition name="el-fade-in" mode="out-in">
            <router-view></router-view>
        </transition>
        <dynamic-box
                :windowStatus="windowStatus"
                :data="wordStudyStage.dataSource"
                :type="wordStudyStage.type"
                @callBack="callBack">
        </dynamic-box>
    </div>
</template>
<script>
    import Lockr from 'lockr'
    import {mapGetters, mapMutations} from 'vuex';
    import {intelligentDictation, isToEnd, intelligentReview, checkBook, wordTestEnd} from '@/api/words'
    import dynamicBox from "../templates/dynamicBox";
    import test from "./allTest/test";

    export default {
        name: "textBookList",
        components: {dynamicBox},
        computed: {
            ...mapGetters(['wordStudyStage'])
        },
        data() {
            return {
                courseInfo: '',//课程信息
                windowStatus: false,
                wordSpellType: '',//听写组件的dataType
                menuLink: [
                    {name: '单词学习', type: 1, url: '/word/pindu/wokabulary'},
                    // {name: '听读训练', type: 2, url: '/word/pindu/listenReadDrill'},
                    {name: '自主测试', type: 2, url: '/word/pindu/selfTest'},
                    {name: '单元测试', type: 4, url: '/word/pindu/unitTest'},
                    {name: '单元听写', type: 5, url: '/word/pindu/unitListen'},
                    {name: '单词学习错题本', type: 6, url: '/word/pindu/wrongTopicStudy'},
                    {name: '单元听写错题本', type: 7, url: '/word/pindu/wrongTopicSpell'},
                ],
                ShowSpellPop: false,//显示语音识别模块
                showComparison: false,//控制一测到底模块
                showBookPop:false,
                showAllTestPop:false,
            };
        },
        methods: {
            ...mapMutations(['CHANGE_WORD_STUDY_TYPE']),
            //课程相关链接
            goLink(item) {
                if (this.$route.query.type == item.type) {
                    return null
                }
                let url = `${item.url}?id=${this.$route.query.id}&type=${item.type}`
                this.$router.replace(url)
            },
            //检查本书测试单元是否学习完
            async checkUnitEnd() {
                let params = {
                    token: Lockr.get('token'),
                    curriculum_id: this.$route.query.id
                }
                let result = await checkBook(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.goBookTest()
                } else {
                    this.showBookPop=true
                    setTimeout(()=>{
                        this.showBookPop=false
                    },1000)
                }
            },
            //本书测试
            goBookTest() {
                let url = '/word/pindu/theBookTest?id=' + this.$route.query.id
                this.$router.push(url)
            },
            //进入对比测试
            startComparision() {
                this.$router.push(`/word/pindu/comparisonTest?id=${this.$route.query.id}`)
            },
            //启动智能听写组件
            startWordSpell() {
                let params = {
                    token: Lockr.get('token'),
                    curriculum_id: this.$route.query.id,
                }
                intelligentDictation(params).then(res => {
                    let data = {
                        title: '智能听写',
                        type: 'smartReview/wordSpell',
                        dataSource: res.data,
                        courseType: 'zntx',
                    }
                    this.CHANGE_WORD_STUDY_TYPE(data)
                    this.windowStatus = true
                })
            },
            //精准复习
            preciseReview() {
                let params = {
                    token: Lockr.get('token'),
                    curriculum_id: this.$route.query.id,
                    sign: 4,
                }
                intelligentReview(params).then(res => {
                    let data = {
                        title: '精准复习',
                        /**
                         * nanfeng 2020年08月11日16:21:35
                         * 精准复习只有一个瓶邪强化步骤
                         */
                        // old
                        // type: 'preciseReview/voiceDiscern',
                        // new
                        type: 'preciseReview/wordSpell',

                        dataSource: res.data,
                        courseType: 'jzfx',//精准复习
                    }
                    this.CHANGE_WORD_STUDY_TYPE(data)
                    this.windowStatus = true
                })

            },
            //关闭拼写强化
            clickedSpellPop() {
                this.ShowSpellPop = false;
            },
            // 开始一测到底
            async startAllTest() {
                let course = this.$route.query.id //课程id
                if (!course) {
                    this.$message({
                        message: '请选择需要测试的课本',
                        type: 'warning'
                    });
                    return null
                }
                let params = {
                    token: Lockr.get('token'),
                    curriculum_id: this.$route.query.id,
                }
                wordTestEnd(params).then(result => {
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        let data = result.data
                        data.edition_id = this.$route.query.id
                        this.DialogStudy({
                            title: '一测到底',
                            closeType: 2,
                            component: test,
                            data: {
                                source: result.data
                            },
                            callback: ()=>{
                                
                            }
                        })
                    } else {
                        this.showAllTestPop=true
                        setTimeout(()=>{
                            this.showAllTestPop=false
                        },1000)
                    }
                })
            },
            // 关闭一测到底
            closeComparison() {
                this.showComparison = false
            },
            // 动态组件回调
            callBack(data) {
                if (data.type == 'close') {
                    this.windowStatus = false;
                }
            },
        },
        watch: {
            $route() {
                this.courseInfo = Lockr.get('courseWord')
            },
        },
        mounted() {
            this.courseInfo = Lockr.get('courseWord')
        }
    }
</script>

<style scoped lang='less'>
    .text-book {
        flex: 1;
        background: #fff;

        .title {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            padding-left: 10px;
            border-left: 3px solid #333;

        }

        .title-text {
            border: 2px solid #F5A623;
            padding: 12px 17px;
            margin: 20px 10px;
            font-size: 14px;
            font-weight: bold;
            color: #333;
            line-height: 19px;
        }

        .class-btn {
            margin: 20px 10px;
            display: flex;
            flex-wrap: wrap;

            div {
                padding: 7px 15px;
                background: #40C2B8;
                margin: 5px 0;
                border-radius: 3px;
                margin-right: 10px;
                color: #fff;
                cursor: pointer;
                transition: all .2s;
                position: relative;
            }

            div:hover {
                opacity: .8;
            }

            .color-1 {
                background: #40C2B8;
            }

            .color-2 {
                background: #F44C65;
            }

            .color-3 {
                background: #5E9CF3;
            }

            .color-4 {
                background: #48D861;
            }

            .color-5 {
                background: #e6a23c;
            }
        }
    }

    .menu-link {
        border-left: 3px solid #333;
        display: flex;
        align-items: center;
        margin: 20px 0;
        flex-wrap: wrap;

        /*height: 20px;*/

        .title {
            padding: 0 10px;
            cursor: pointer;
            font-size: 15px;
            margin: 10px 0;
        }

        .title:hover {
            color: #469ff2;
        }

        .title:not(:last-child) {
            border-right: 1px solid #333;
        }

        .active-item {
            color: #469ff2;
        }
    }
    .lock-unit {
        position: absolute!important;
        top: -45px;
        left: 20px;
        font-size: 14px;
        white-space: nowrap;
        padding: 5px 8px;
        background: #00b29f;
    }

    .lock-unit:before {
        position: absolute;
        border: 5px solid;
        border-color: #00b29f transparent transparent transparent;
        content: '';
        bottom: -10px;
    }
    @media (min-width: 1200px) {
        .title-text {
            font-size: 16px!important;
        }
    }
</style>